export default __webpack_public_path__ + "static/media/onboarding_gifts_4.1f660b3e.png";